import { API_RESEND_DOUBLE_OPT_IN_MAIL_URL } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";

export const useResendDoubleOptInEmailMutation = () => {
    return useMutation(API_RESEND_DOUBLE_OPT_IN_MAIL_URL);
};

export type IResendDoubleOptInEmailMutation = ReturnType<typeof useResendDoubleOptInEmailMutation>;
